import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('cita', ['pageType']),

    steps() {
      switch (this.pageType) {
        case 'ANONYMOUS':
          return [{ name: 'cita.yourphonenumber' }, { name: 'cita.youridentcode' }, { name: 'cita.yourconfirmation' }];
        case 'NON_ANONYMOUS_SIMPLE':
        case 'NON_ANONYMOUS_CAPTCHA':
        case 'NON_ANONYMOUS_XTC_OTP':
          return [{ name: 'cita.yourconfirmation' }];
        case 'NON_ANONYMOUS_CAP_OTP':
          return [{ name: 'cita.youridentcode' }, { name: 'cita.yourconfirmation' }];
      }
    },
  },
};
